import { all, takeEvery, put, call, select } from "redux-saga/effects";
import actions from "./actions";
import profileActions from "../profile/actions";
import * as services from "./services";

const getProfileState = (state) => state.profile;

export function* GET_NOTIFICATION_CONNECTION() {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });

  const notifications = yield call(services.getNotifications, currentUser.uid);
  const pending = [];
  for (let i = 0; i < notifications.length; i++) {
    const user = yield call(services.getUserById, notifications[i].uid);
    pending.push({ notification: notifications[i], user });
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false, pending },
  });
}

export function* GET_SENT_REQUESTS() {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  const notifications = yield call(
    services.getSentNotifications,
    currentUser.uid
  );
  const sent = [];
  for (let i = 0; i < notifications.length; i++) {
    const user = yield call(services.getUserById, notifications[i].userId);
    sent.push({ notification: notifications[i], user });
  }
  yield put({
    type: actions.SET_STATE,
    payload: { loading: false, sent },
  });
}

export function* UPDATE_NOTIFICATION({ payload }) {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  // set music hidden
  yield call(
    services.updateNotification,
    currentUser.uid,
    payload.notifId,
    payload.status
  );

  if (payload.status === 1) {
    yield call(services.acceptConnection, currentUser.uid, payload.senderId);
  }

  yield put({
    type: actions.GET_CONNECTIONS_LIST,
  });
  yield put({
    type: actions.GET_NOTIFICATION_CONNECTION,
  });
}

export function* GET_CONNECTIONS_LIST() {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  const ids = yield call(services.getConnectionIds, currentUser.uid);
  const findIndex = ids.findIndex((a) => a === currentUser.uid);
  if (findIndex > 0) {
    ids.splice(findIndex, 1);
  }
  const connections = [];
  for (let i = 0; i < ids.length; i++) {
    const user = yield call(services.getUserById, ids[i]);
    connections.push(user);
  }

  yield put({
    type: actions.SET_STATE,
    payload: { connections },
  });

  yield put({
    type: actions.GET_NOTIFICATION_CONNECTION,
  });
}

export function* GET_CONNECTIONS_LIST_REQUESTS() {
  const { currentUser } = yield select(getProfileState);
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  const ids = yield call(services.getConnectionrequests, currentUser.uid);
  const findIndex = ids.findIndex((a) => a === currentUser.uid);
  if (findIndex > 0) {
    ids.splice(findIndex, 1);
  }
  const connections = [];
  for (let i = 0; i < ids.length; i++) {
    const user = yield call(services.getUserById, ids[i]);
    connections.push(user);
  }

  yield put({
    type: actions.SET_STATE,
    payload: { connections },
  });

  yield put({
    type: actions.GET_NOTIFICATION_CONNECTION,
  });
}

export function* FIND_ALL({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  // set music hidden
  const allUsers = yield call(services.findAll);

  yield put({
    type: actions.SET_STATE,
    payload: { loading: false, allUsers },
  });

  yield put({
    type: actions.GET_NOTIFICATION_CONNECTION,
  });
  yield put({
    type: actions.GET_SENT_REQUESTS,
  });
  yield put({
    type: actions.GET_CONNECTIONS_LIST,
  });
}

// export function* SEND_CONNECT_REQURST({ payload }) {
//   yield put({
//     type: actions.SET_STATE,
//     payload: { loading: true },
//   });
//   const { userId } = payload;
//   const { currentUser } = yield select(getProfileState);
//   yield call(services.sendRequest, currentUser.uid, userId);
//   yield put({
//     type: actions.FIND_ALL,
//   });
// }

export function* SEND_CONNECT_REQURST({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  });
  const { userId } = payload;
  const { currentUser } = yield select(getProfileState);
  yield call(services.sendRequest, currentUser.uid, userId);
  yield put({
    type: actions.FIND_ALL,
  });
}

// export function* GET_CONNECTIONS_LISTS() {
//   const { currentUser } = yield select(getProfileState);
//   yield put({
//     type: actions.SET_STATE,
//     payload: { loading: true },
//   });
//    yield call(services.getConnections, currentUser.uid);
//   const findIndex = ids.findIndex((a) => a === currentUser.uid);
//   if (findIndex > 0) {
//     ids.splice(findIndex, 1);
//   }
//   const connections = [];
//   for (let i = 0; i < ids.length; i++) {
//     const user = yield call(services.getUserById, ids[i]);
//     connections.push(user);
//   }

//   yield put({
//     type: actions.SET_STATE,
//     payload: { connections },
//   });

//   yield put({
//     type: actions.GET_NOTIFICATION_CONNECTION,
//   });
// }

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_NOTIFICATION_CONNECTION, GET_NOTIFICATION_CONNECTION),
    takeEvery(actions.GET_SENT_REQUESTS, GET_SENT_REQUESTS),
    takeEvery(actions.UPDATE_NOTIFICATION, UPDATE_NOTIFICATION),
    takeEvery(actions.GET_CONNECTIONS_LIST, GET_CONNECTIONS_LIST),
    takeEvery(actions.SEND_CONNECT_REQURST, SEND_CONNECT_REQURST),
    takeEvery(actions.FIND_ALL, FIND_ALL),
    // takeEvery(actions.GET_CONNECTIONS_LISTAll),
  ]);
}
